module.exports = __webpack_public_path__ + "static/media/history-alt.066e6682.svg";